export default function Premium() {
  return (
    <section className="relative w-full bg-background-100 overflow-hidden" id="premium">
      <div className="relative section-padding py-20 md:py-28">
        <p className="text-xs md:text-sm font-medium text-primary-500 tracking-[0.3em] mb-2">
          HEYRI AUVERSONE
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 mb-8 md:mb-12">
          프리미엄
        </h2>
        <img
          alt="헤이리 오베르원 프리미엄"
          className="w-full max-w-5xl mx-auto h-auto rounded-lg border border-background-200/30"
          src="https://www.xn--2w2b1dm8gn5nwya81ag35e.com/assets/images/sub/premium_0410.jpg"
        />
      </div>
    </section>
  );
}